import React from "react";
import "./Loading.css";

export default function Loading() {
  return (
    <div className="loadingEllipsisContainer">
      <div className="loadingEllipsisContainer__lds-ellipsis">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}
